export default "__VITE_ASSET__BpLHy150__"